const REQUEST_ORGANIZATION_ROLES = 'REQUEST_ORGANIZATION_ROLES';
const REQUEST_ORGANIZATION_ROLES_FAIL = 'REQUEST_ORGANIZATION_ROLES_FAIL';
const REQUEST_ORGANIZATION_ROLES_SUCCESS = 'REQUEST_ORGANIZATION_ROLES_SUCCESS';

export {
  REQUEST_ORGANIZATION_ROLES,
  REQUEST_ORGANIZATION_ROLES_FAIL,
  REQUEST_ORGANIZATION_ROLES_SUCCESS,
};
